<template>
  <div :class="containerClass">
    <input v-model="modelValue" :id="inputId" type="checkbox" checked="" />

    <label :for="inputId">{{ label }}</label>
  </div>
</template>

<script setup>
defineProps({
  inputId: {
    type: String,
    default: 'remember_me',
  },
  label: {
    type: String,
    default: '',
  },
  containerClass: {
    type: String,
    default: 'remember_checkbox',
  },
});

const modelValue = defineModel({
  type: Boolean,
});

</script>
